import { render, staticRenderFns } from "./plan.vue?vue&type=template&id=c763e4c0&scoped=true"
import script from "./plan.vue?vue&type=script&lang=js"
export * from "./plan.vue?vue&type=script&lang=js"
import style0 from "./plan.vue?vue&type=style&index=0&id=c763e4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c763e4c0",
  null
  
)

export default component.exports